import { Box, Divider, Grid } from '@mui/material'

import { ReactNode, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import checkListOperative from 'assets/branch/setting/checkListOperative.png'
import checkTeethFalse from 'assets/branch/setting/checkTeethFalse.png'
import checkTeethTrue from 'assets/branch/setting/checkTeethTrue.png'
import registerFalse from 'assets/branch/setting/registerFalse.png'
import registerTrue from 'assets/branch/setting/registerTrue.png'
import { colors } from 'constants/theme'

import { PACKAGE_ADDONS } from 'constants/package'
import { ALERT_BEFORE_PAYMENT, APPOINTMENT_SHARING, CALCULATE_ADVANCE, CODE_OPERATIVE, DCC_TREATMENT_COST, OPERATIVE_COLOR, REQUIRE_FINANCE_ACKNOWLEDGE } from 'constants/status'
import { checkAddons } from 'utils/app.utils'
import SelectInput from 'new-components/inputs/select-input'
import { DEFAULT_DF_CON, DEFAULT_DF_REPORT, PATIENT_CODE, TIME_APPOINTMENT, TREATMENT } from './form-branch'
import OpShowAppointmentSharing from './preview-setting/appointment-sharing'
import OpAppointmentTime from './preview-setting/appointment-time'
import OpCalAdvance from './preview-setting/cal-advance'
import OpShowOperativeCode from './preview-setting/code_operative'
import OpShowDccTreatmentCost from './preview-setting/dcc-treatment-cost'
import OpModelDF from './preview-setting/model-DF'
import OpShowOperativeColor from './preview-setting/operative-color'
import OpDF from './preview-setting/preview-DF'
import OpShowPatient from './preview-setting/show-patient'
import OpTreatment from './preview-setting/treatment'


type FormBranchSettingProps = {
    showPatient: string
    setShowPatient: (value: PATIENT_CODE.CN | PATIENT_CODE.PT | PATIENT_CODE.SN) => void
    appointmentTime: string
    setAppointmentTime: (value: TIME_APPOINTMENT.CLINIC | TIME_APPOINTMENT.SCHEDULE) => void
    treatment: string
    setTreatment: (value: TREATMENT.TYPE | TREATMENT.TX) => void
    preveiwDf: string
    setPreveiwDf: (value: DEFAULT_DF_REPORT.PAY | DEFAULT_DF_REPORT.OP) => void
    modelDf: string
    setModelDf: (value: DEFAULT_DF_CON.PAY_1 | DEFAULT_DF_CON.PAY_2 | DEFAULT_DF_CON.PAY_3 | DEFAULT_DF_CON.PAY_4 | DEFAULT_DF_CON.PAY_5) => void
    calAdvance: string
    setCalAdvance: (value: CALCULATE_ADVANCE.INCREASE | CALCULATE_ADVANCE.DECREASE) => void
    showOperativeCode: string
    setShowOperativeCode: (value: CODE_OPERATIVE.NOT_DISPLAYED | CODE_OPERATIVE.SHOW) => void
    showAppointmentSharing: string
    setShowAppointmentSharing: (value: APPOINTMENT_SHARING.NOT_DISPLAYED | APPOINTMENT_SHARING.SHOW) => void
    showOperativeColor: string
    setShowOperativeColor: (value: OPERATIVE_COLOR.NOT_DISPLAYED | OPERATIVE_COLOR.SHOW) => void
    showDccTreatmentCost: string
    setShowDccTreatmentCost: (value: DCC_TREATMENT_COST.NOT_DISPLAYED | DCC_TREATMENT_COST.SHOW) => void
    alertXrayBeforePayment: string
    setAlertXrayBeforePayment: (value: ALERT_BEFORE_PAYMENT.DISABLED | ALERT_BEFORE_PAYMENT.ENABLED) => void
    alertMedicineBeforePayment: string
    setAlertMedicineBeforePayment: (value: ALERT_BEFORE_PAYMENT.DISABLED | ALERT_BEFORE_PAYMENT.ENABLED) => void
    alertTeethBeforePayment: string
    setAlertTeethBeforePayment: (value: ALERT_BEFORE_PAYMENT.DISABLED | ALERT_BEFORE_PAYMENT.ENABLED) => void
    requireFinanceAcknowledge: string
    setRequireFinanceAcknowledge: (value: REQUIRE_FINANCE_ACKNOWLEDGE.DISABLED | REQUIRE_FINANCE_ACKNOWLEDGE.ENABLED) => void
    allowNewPatientRegistration: string
    setAllowNewPatientRegistration: (value: ALERT_BEFORE_PAYMENT.DISABLED | ALERT_BEFORE_PAYMENT.ENABLED) => void
}

const FormBranchSetting = (props: FormBranchSettingProps) => {
    const { t } = useTranslation()

    const { showPatient, setShowPatient, appointmentTime, setAppointmentTime, preveiwDf, setPreveiwDf, modelDf, setModelDf, calAdvance, setCalAdvance, treatment, setTreatment, showOperativeCode, setShowOperativeCode, showAppointmentSharing, setShowAppointmentSharing, showOperativeColor, setShowOperativeColor, showDccTreatmentCost, setShowDccTreatmentCost, alertXrayBeforePayment, setAlertXrayBeforePayment, alertMedicineBeforePayment, setAlertMedicineBeforePayment, alertTeethBeforePayment, setAlertTeethBeforePayment, requireFinanceAcknowledge, setRequireFinanceAcknowledge, allowNewPatientRegistration, setAllowNewPatientRegistration } = props

    const [openSelectInput, setOpenSelectInput] = useState(false)
    const [previewComponent, setPreviewComponent] = useState<ReactNode>(<></>)

    const [selectInput, setSelectInput] = useState('optionShowPatient')

    const optionShowPatient = OpShowPatient()
    const optionAppointmentTime = OpAppointmentTime()
    const optionTreatment = OpTreatment()
    const optionDF = OpDF()
    const optionModelDF = OpModelDF()
    const optionCalAdvance = OpCalAdvance()
    const optionShowOperativeCode = OpShowOperativeCode()
    const optionShowAppointmentSharing = OpShowAppointmentSharing()
    const optionShowOperativeColor = OpShowOperativeColor()
    const optionShowDccTreatmentCost = OpShowDccTreatmentCost()
    const optionAlertXray = [
        { name: t('BRANCH.TAB.SENTTING.PATTERN_ALERT_XRAY.SHOW'), value: ALERT_BEFORE_PAYMENT.ENABLED, component: <AlertXrayPreview isEnabled={true} /> },
        { name: t('BRANCH.TAB.SENTTING.PATTERN_ALERT_XRAY.NOT_SHOW'), value: ALERT_BEFORE_PAYMENT.DISABLED, component: <AlertXrayPreview isEnabled={false} /> }
    ]
    const optionAlertMedicine = [
        { name: t('BRANCH.TAB.SENTTING.PATTERN_ALERT_MEDICINE.SHOW'), value: ALERT_BEFORE_PAYMENT.ENABLED, component: <AlertMedicinePreview isEnabled={true} /> },
        { name: t('BRANCH.TAB.SENTTING.PATTERN_ALERT_MEDICINE.NOT_SHOW'), value: ALERT_BEFORE_PAYMENT.DISABLED, component: <AlertMedicinePreview isEnabled={false} /> }
    ]
    const optionAlertTeeth = [
        { name: t('BRANCH.TAB.SENTTING.PATTERN_ALERT_TEETH.SHOW'), value: ALERT_BEFORE_PAYMENT.ENABLED, component: <AlertTeethPreview isEnabled={true} /> },
        { name: t('BRANCH.TAB.SENTTING.PATTERN_ALERT_TEETH.NOT_SHOW'), value: ALERT_BEFORE_PAYMENT.DISABLED, component: <AlertTeethPreview isEnabled={false} /> }
    ]
    const optionRequireFinanceAcknowledge = [
        { name: 'เปิดใช้งาน', value: REQUIRE_FINANCE_ACKNOWLEDGE.ENABLED, component: <RequireFinanceAcknowledgePreview isEnabled={true} /> },
        { name: 'ปิดใช้งาน', value: REQUIRE_FINANCE_ACKNOWLEDGE.DISABLED, component: <RequireFinanceAcknowledgePreview isEnabled={false} /> }
    ]
    const optionAllowNewPatientRegistration = [
        { name: 'เปิดใช้งาน', value: ALERT_BEFORE_PAYMENT.ENABLED, component: <AllowNewPatientRegistrationPreview isEnabled={true} /> },
        { name: 'ปิดใช้งาน', value: ALERT_BEFORE_PAYMENT.DISABLED, component: <AllowNewPatientRegistrationPreview isEnabled={false} /> }
    ]

    const handleChangePreviewComponent = (op: any[], data: any) => {
        const newComponent = op.find((item) => item.value === data)?.component || <>Unknow</>
        setPreviewComponent(newComponent)
        setOpenSelectInput(false)
    }

    const handlePreviewInfo = (pre: string) => {
        setSelectInput(pre)
        if (openSelectInput) {
            setOpenSelectInput(false)
            return
        }
        switch (pre) {
            case 'optionShowPatient':
                handleChangePreviewComponent(optionShowPatient, showPatient)
                break;
            case 'optionAppointmentTime':
                handleChangePreviewComponent(optionAppointmentTime, appointmentTime)
                break;
            case 'optionTreatment':
                handleChangePreviewComponent(optionTreatment, treatment)
                break;
            case 'optionShowAppointmentSharing':
                handleChangePreviewComponent(optionShowAppointmentSharing, showAppointmentSharing)
                break;
            case 'optionShowOperativeColor':
                handleChangePreviewComponent(optionShowOperativeColor, showOperativeColor)
                break;
            case 'optionDF':
                handleChangePreviewComponent(optionDF, preveiwDf)
                break;
            case 'optionModelDF':
                handleChangePreviewComponent(optionModelDF, modelDf)
                break;
            case 'optionShowOperativeCode':
                handleChangePreviewComponent(optionShowOperativeCode, showOperativeCode)
                break;
            case 'optionShowDccTreatmentCost':
                handleChangePreviewComponent(optionShowDccTreatmentCost, showDccTreatmentCost)
                break;
            case 'optionAlertXray':
                handleChangePreviewComponent(optionAlertXray, alertXrayBeforePayment)
                break;
            case 'optionAlertMedicine':
                handleChangePreviewComponent(optionAlertMedicine, alertMedicineBeforePayment)
                break;
            case 'optionAlertTeeth':
                handleChangePreviewComponent(optionAlertTeeth, alertTeethBeforePayment)
                break;
            case 'optionRequireFinanceAcknowledge':
                handleChangePreviewComponent(optionRequireFinanceAcknowledge, requireFinanceAcknowledge)
                break;
            case 'optionAllowNewPatientRegistration':
                handleChangePreviewComponent(optionAllowNewPatientRegistration, allowNewPatientRegistration)
                break;
            default:
                handleChangePreviewComponent(optionCalAdvance, calAdvance)
        }

    }

    useEffect(() => {
        handlePreviewInfo('optionShowPatient')
    }, [])

    return (
        <Box>
            <Grid container className="mt-3" display='flex'>
                <Grid container item lg={6} xs={12}
                    maxWidth={{ lg: '670px !important', xs: '100%' }}
                    width={{ lg: '50%', xs: '100%' }}
                    paddingRight={{ lg: '12px', xs: '0' }}
                    height={'fit-content'}
                    maxHeight={'calc(100vh - 280px)'}
                    sx={{ overflowY: 'auto' }}
                >

                    <Grid container item padding='8px 0' onClick={() => handlePreviewInfo('optionShowPatient')}>
                        <Grid item sm={6} alignContent="center">
                            <Box
                                bgcolor={selectInput === 'optionShowPatient' ? colors.themeSecondColor06 : ''}
                                padding="8px 16px 8px 16px"
                                borderRadius="32px"
                                display="inline-block"
                            >
                                <Box color={selectInput === 'optionShowPatient' ? colors.themeSecondColor : ''}>
                                    {t('BRANCH.TAB.SENTTING.SHOWPATIENT')}{t('BRANCH.TAB.SENTTING.SYSTEM')}
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item sm={6}>
                            <SelectInput
                                onOpen={() => setOpenSelectInput(true)}
                                label=''
                                onChange={(e) => {
                                    const data = e.target.value
                                    setShowPatient(data)
                                    handleChangePreviewComponent(optionShowPatient, data)
                                }}
                                options={optionShowPatient}
                                value={showPatient.toString()}
                            />
                        </Grid>
                    </Grid>
                    <Divider sx={{ width: '100%', my: 3, bgcolor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
                    <Grid container item padding='8px 0' onClick={() => handlePreviewInfo('optionAppointmentTime')}>
                        <Grid item sm={6} alignContent="center">
                            <Box
                                bgcolor={selectInput === 'optionAppointmentTime' ? colors.themeSecondColor06 : ''}
                                padding="8px 16px 8px 16px"
                                borderRadius="32px"
                                display="inline-block"
                            >
                                <Box color={selectInput === 'optionAppointmentTime' ? colors.themeSecondColor : ''}>
                                    {t('BRANCH.INPUT.APPOINTMENT_TIME')}
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item sm={6}>
                            <SelectInput
                                onOpen={() => setOpenSelectInput(true)}
                                label=''
                                onChange={(e) => {
                                    const data = e.target.value
                                    setAppointmentTime(data)
                                    handleChangePreviewComponent(optionAppointmentTime, data)
                                }}
                                options={optionAppointmentTime}
                                value={appointmentTime.toString()}
                            />
                        </Grid>
                    </Grid>
                    <Divider sx={{ width: '100%', my: 3, bgcolor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
                    <Grid container item padding='8px 0' onClick={() => handlePreviewInfo('optionTreatment')}>
                        <Grid item sm={6} alignContent="center">
                            <Box
                                bgcolor={selectInput === 'optionTreatment' ? colors.themeSecondColor06 : ''}
                                padding="8px 16px 8px 16px"
                                borderRadius="32px"
                                display="inline-block"
                            >
                                <Box color={selectInput === 'optionTreatment' ? colors.themeSecondColor : ''}>
                                    {t('BRANCH.INPUT.APPT_SERVICE')}
                                </Box>
                            </Box>
                        </Grid>

                        <Grid item sm={6}>
                            <SelectInput
                                onOpen={() => setOpenSelectInput(true)}
                                label=''
                                onChange={(e) => {
                                    const data = e.target.value
                                    setTreatment(data)
                                    handleChangePreviewComponent(optionTreatment, data)
                                }}
                                options={optionTreatment}
                                value={treatment.toString()}
                            />
                        </Grid>
                    </Grid>
                    <Divider sx={{ width: '100%', my: 3, bgcolor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
                    <Grid container item padding='8px 0' onClick={() => handlePreviewInfo('optionShowAppointmentSharing')}>
                        <Grid item sm={6} alignContent="center">
                            <Box
                                bgcolor={selectInput === 'optionShowAppointmentSharing' ? colors.themeSecondColor06 : ''}
                                padding="8px 16px 8px 16px"
                                borderRadius="32px"
                                display="inline-block"
                            >
                                <Box color={selectInput === 'optionShowAppointmentSharing' ? colors.themeSecondColor : ''}>
                                    {t('BRANCH.TAB.SENTTING.APPOINTMENT_SHARING')}
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item sm={6}>
                            <SelectInput
                                onOpen={() => setOpenSelectInput(true)}
                                label=''
                                onChange={(e) => {
                                    const data = e.target.value
                                    setShowAppointmentSharing(data)
                                    handleChangePreviewComponent(optionShowAppointmentSharing, data)
                                }}
                                options={optionShowAppointmentSharing}
                                value={showAppointmentSharing}
                            />
                        </Grid>
                    </Grid>
                    <Divider sx={{ width: '100%', my: 3, bgcolor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
                    <Grid container item padding='8px 0' onClick={() => handlePreviewInfo('optionShowOperativeColor')}>
                        <Grid item sm={6} alignContent="center">
                            <Box
                                bgcolor={selectInput === 'optionShowOperativeColor' ? colors.themeSecondColor06 : ''}
                                padding="8px 16px 8px 16px"
                                borderRadius="32px"
                                display="inline-block"
                            >
                                <Box color={selectInput === 'optionShowOperativeColor' ? colors.themeSecondColor : ''}>
                                    {t('BRANCH.TAB.SENTTING.OPERATIVE_COLOR')}
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item sm={6}>
                            <SelectInput
                                onOpen={() => setOpenSelectInput(true)}
                                label=''
                                onChange={(e) => {
                                    const data = e.target.value
                                    setShowOperativeColor(data)
                                    handleChangePreviewComponent(optionShowOperativeColor, data)
                                }}
                                options={optionShowOperativeColor}
                                value={showOperativeColor}
                            />
                        </Grid>
                    </Grid>
                    <Divider sx={{ width: '100%', my: 3, bgcolor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
                    <Grid container item padding='8px 0' onClick={() => handlePreviewInfo('optionDF')}>
                        <Grid item sm={6} alignContent="center">
                            <Box
                                bgcolor={selectInput === 'optionDF' ? colors.themeSecondColor06 : ''}
                                padding="8px 16px 8px 16px"
                                borderRadius="32px"
                                display="inline-block"
                            >
                                <Box color={selectInput === 'optionDF' ? colors.themeSecondColor : ''}>
                                    {t('BRANCH.TAB.SENTTING.DF_TREAMENT')}
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item sm={6}>
                            <SelectInput
                                onOpen={() => setOpenSelectInput(true)}
                                label=''
                                onChange={(e) => {
                                    const data = e.target.value
                                    setPreveiwDf(data)
                                    handleChangePreviewComponent(optionDF, data)
                                }}
                                options={optionDF}
                                value={preveiwDf.toString()}
                            />
                        </Grid>
                    </Grid>
                    <Divider sx={{ width: '100%', my: 3, bgcolor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
                    <Grid container item padding='8px 0' onClick={() => handlePreviewInfo('optionModelDF')}>
                        <Grid item sm={6} alignContent="center">
                            <Box
                                bgcolor={selectInput === 'optionModelDF' ? colors.themeSecondColor06 : ''}
                                padding="8px 16px 8px 16px"
                                borderRadius="32px"
                                display="inline-block"
                            >
                                <Box color={selectInput === 'optionModelDF' ? colors.themeSecondColor : ''}>
                                    {t('BRANCH.TAB.SENTTING.CONDITION_REPORT_DF')}
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item sm={6}>
                            <SelectInput
                                onOpen={() => setOpenSelectInput(true)}
                                label=''
                                onChange={(e) => {
                                    const data = e.target.value
                                    setModelDf(data)
                                    handleChangePreviewComponent(optionModelDF, data)
                                }}
                                options={optionModelDF}
                                value={modelDf.toString()}
                            />
                        </Grid>
                    </Grid>
                    <Divider sx={{ width: '100%', my: 3, bgcolor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
                    <Grid container item padding='8px 0' onClick={() => handlePreviewInfo('optionCalAdvance')}>
                        <Grid item sm={6} alignContent="center">
                            <Box
                                bgcolor={selectInput === 'optionCalAdvance' ? colors.themeSecondColor06 : ''}
                                padding="8px 16px 8px 16px"
                                borderRadius="32px"
                                display="inline-block"
                            >
                                <Box color={selectInput === 'optionCalAdvance' ? colors.themeSecondColor : ''}>
                                    {t('BRANCH.TAB.SENTTING.CAL_ADVANCE')}
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item sm={6}>
                            <SelectInput
                                onOpen={() => setOpenSelectInput(true)}
                                label=''
                                onChange={(e) => {
                                    const data = e.target.value
                                    setCalAdvance(data)
                                    handleChangePreviewComponent(optionCalAdvance, data)
                                }}
                                options={optionCalAdvance}
                                value={calAdvance.toString()}
                            />
                        </Grid>
                    </Grid>
                    <Divider sx={{ width: '100%', my: 3, bgcolor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
                    <Grid container item padding='8px 0' onClick={() => handlePreviewInfo('optionShowOperativeCode')}>
                        <Grid item sm={6} alignContent="center">
                            <Box
                                bgcolor={selectInput === 'optionShowOperativeCode' ? colors.themeSecondColor06 : ''}
                                padding="8px 16px 8px 16px"
                                borderRadius="32px"
                                display="inline-block"
                            >
                                <Box color={selectInput === 'optionShowOperativeCode' ? colors.themeSecondColor : ''}>
                                    {t('BRANCH.TAB.SENTTING.CODE_OPERATIVE')}
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item sm={6}>
                            <SelectInput
                                onOpen={() => setOpenSelectInput(true)}
                                label=''
                                onChange={(e) => {
                                    const data = e.target.value
                                    setShowOperativeCode(data)
                                    handleChangePreviewComponent(optionShowOperativeCode, data)
                                }}
                                options={optionShowOperativeCode}
                                value={showOperativeCode}
                            />
                        </Grid>
                    </Grid>
                    {checkAddons(PACKAGE_ADDONS.ADDON_DCC) && (
                        <>
                            <Divider sx={{ width: '100%', my: 3, bgcolor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
                            <Grid container item padding='8px 0' onClick={() => handlePreviewInfo('optionShowDccTreatmentCost')}>
                                <Grid item sm={6} alignContent="center">
                                    <Box
                                        bgcolor={selectInput === 'optionShowDccTreatmentCost' ? colors.themeSecondColor06 : ''}
                                        padding="8px 16px 8px 16px"
                                        borderRadius="32px"
                                        display="inline-block"
                                    >
                                        <Box color={selectInput === 'optionShowDccTreatmentCost' ? colors.themeSecondColor : ''}>
                                            {t('BRANCH.TAB.SENTTING.DCC_TREATMENT_COST')}
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid item sm={6}>
                                    <SelectInput
                                        onOpen={() => setOpenSelectInput(true)}
                                        label=''
                                        onChange={(e) => {
                                            const data = e.target.value
                                            setShowDccTreatmentCost(data)
                                            handleChangePreviewComponent(optionShowDccTreatmentCost, data)
                                        }}
                                        options={optionShowDccTreatmentCost}
                                        value={showDccTreatmentCost}
                                    />
                                </Grid>
                            </Grid>
                        </>
                    )}
                    {checkAddons(PACKAGE_ADDONS.ADDON_ALERT_NO_TREATMENT) && (
                        <>
                            <Divider sx={{ width: '100%', my: 3, bgcolor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
                            <Grid container item padding='8px 0' onClick={() => handlePreviewInfo('optionAlertXray')}>
                                <Grid item sm={6} alignContent="center">
                                    <Box
                                        bgcolor={selectInput === 'optionAlertXray' ? colors.themeSecondColor06 : ''}
                                        padding="8px 16px 8px 16px"
                                        borderRadius="32px"
                                        display="inline-block"
                                    >
                                        <Box color={selectInput === 'optionAlertXray' ? colors.themeSecondColor : ''}>
                                            {t('BRANCH.TAB.SENTTING.ALERT_XRAY_BEFORE_PAYMENT')}
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid item sm={6}>
                                    <SelectInput
                                        onOpen={() => setOpenSelectInput(true)}
                                        label=''
                                        onChange={(e) => {
                                            const data = e.target.value
                                            setAlertXrayBeforePayment(data)
                                            handleChangePreviewComponent(optionAlertXray, data)
                                        }}
                                        options={optionAlertXray}
                                        value={alertXrayBeforePayment}
                                    />
                                </Grid>
                            </Grid>
                        </>
                    )}
                    {checkAddons(PACKAGE_ADDONS.ADDON_ALERT_NO_MEDICINE) && (
                        <>
                            <Divider sx={{ width: '100%', my: 3, bgcolor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
                            <Grid container item padding='8px 0' onClick={() => handlePreviewInfo('optionAlertMedicine')}>
                                <Grid item sm={6} alignContent="center">
                                    <Box
                                        bgcolor={selectInput === 'optionAlertMedicine' ? colors.themeSecondColor06 : ''}
                                        padding="8px 16px 8px 16px"
                                        borderRadius="32px"
                                        display="inline-block"
                                    >
                                        <Box color={selectInput === 'optionAlertMedicine' ? colors.themeSecondColor : ''}>
                                            {t('BRANCH.TAB.SENTTING.ALERT_MEDICINE_BEFORE_PAYMENT')}
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid item sm={6}>
                                    <SelectInput
                                        onOpen={() => setOpenSelectInput(true)}
                                        label=''
                                        onChange={(e) => {
                                            const data = e.target.value
                                            setAlertMedicineBeforePayment(data)
                                            handleChangePreviewComponent(optionAlertMedicine, data)
                                        }}
                                        options={optionAlertMedicine}
                                        value={alertMedicineBeforePayment}
                                    />
                                </Grid>
                            </Grid>
                        </>
                    )}
                    {checkAddons(PACKAGE_ADDONS.ADDON_ALERT_TEETH_BEFORE_PAYMENT) && (
                        <>
                            <Divider sx={{ width: '100%', my: 3, bgcolor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
                            <Grid container item padding='8px 0' onClick={() => handlePreviewInfo('optionAlertTeeth')}>
                                <Grid item sm={6} alignContent="center">
                                    <Box
                                        bgcolor={selectInput === 'optionAlertTeeth' ? colors.themeSecondColor06 : ''}
                                        padding="8px 16px 8px 16px"
                                        borderRadius="32px"
                                        display="inline-block"
                                    >
                                        <Box color={selectInput === 'optionAlertTeeth' ? colors.themeSecondColor : ''}>
                                            {t('BRANCH.TAB.SENTTING.ALERT_TEETH_BEFORE_PAYMENT')}
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid item sm={6}>
                                    <SelectInput
                                        onOpen={() => setOpenSelectInput(true)}
                                        label=''
                                        onChange={(e) => {
                                            const data = e.target.value
                                            setAlertTeethBeforePayment(data)
                                            handleChangePreviewComponent(optionAlertTeeth, data)
                                        }}
                                        options={optionAlertTeeth}
                                        value={alertTeethBeforePayment}
                                    />
                                </Grid>
                            </Grid>
                        </>
                    )}
                    {checkAddons(PACKAGE_ADDONS.ADDON_REQUIRE_FINANCE_ACKNOWLEDGE) && (
                        <>
                            <Divider sx={{ width: '100%', my: 3, bgcolor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
                            <Grid container item padding='8px 0' onClick={() => handlePreviewInfo('optionRequireFinanceAcknowledge')}>
                                <Grid item sm={6} alignContent="center">
                                    <Box
                                        bgcolor={selectInput === 'optionRequireFinanceAcknowledge' ? colors.themeSecondColor06 : ''}
                                        padding="8px 16px 8px 16px"
                                        borderRadius="32px"
                                        display="inline-block"
                                    >
                                        <Box color={selectInput === 'optionRequireFinanceAcknowledge' ? colors.themeSecondColor : ''}>
                                            การเงินเซ็นรับทราบก่อนอนุมัติค้างชำระ
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid item sm={6}>
                                    <SelectInput
                                        onOpen={() => setOpenSelectInput(true)}
                                        label=''
                                        onChange={(e) => {
                                            const data = e.target.value
                                            setRequireFinanceAcknowledge(data)
                                            handleChangePreviewComponent(optionRequireFinanceAcknowledge, data)
                                        }}
                                        options={optionRequireFinanceAcknowledge}
                                        value={requireFinanceAcknowledge}
                                    />
                                </Grid>
                            </Grid>
                        </>
                    )}
                    {checkAddons(PACKAGE_ADDONS.ADDON_NEW_OLD_PATIENT) && (
                        <>
                            <Divider sx={{ width: '100%', my: 3, bgcolor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
                            <Grid container item padding='8px 0' onClick={() => handlePreviewInfo('optionAllowNewPatientRegistration')}>
                                <Grid item sm={6} alignContent="center">
                                    <Box
                                        bgcolor={selectInput === 'optionAllowNewPatientRegistration' ? colors.themeSecondColor06 : ''}
                                        padding="8px 16px 8px 16px"
                                        borderRadius="32px"
                                        display="inline-block"
                                    >
                                        <Box color={selectInput === 'optionAllowNewPatientRegistration' ? colors.themeSecondColor : ''}>
                                            การแสดงประเภทผู้ป่วย
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid item sm={6}>
                                    <SelectInput
                                        onOpen={() => setOpenSelectInput(true)}
                                        label=''
                                        onChange={(e) => {
                                            const data = e.target.value
                                            setAllowNewPatientRegistration(data)
                                            handleChangePreviewComponent(optionAllowNewPatientRegistration, data)
                                        }}
                                        options={optionAllowNewPatientRegistration}
                                        value={allowNewPatientRegistration}
                                    />
                                </Grid>
                            </Grid>
                        </>
                    )}
                    <Divider sx={{ width: '100%', my: 3, bgcolor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
                </Grid>
                <Grid lg xs={0} height={'fit-content'}
                    maxHeight={'calc(100vh - 300px)'}
                    sx={{ overflowY: 'auto' }}>
                    <Box width='100%' height='100%' padding='16px' bgcolor={'#F7F8F8'}>
                        <FormBranchSettingPreview component={previewComponent} />
                    </Box>
                </Grid>
            </Grid >
        </Box>
    )
}

export default FormBranchSetting

interface FormSettingPreviewProps {
    component: ReactNode
}
const FormBranchSettingPreview = (props: FormSettingPreviewProps) => {
    const { component } = props
    return (
        <Box>
            {component}
        </Box>
    )
}

// Preview component for Alert X-ray
const AlertXrayPreview = ({ isEnabled }: { isEnabled: boolean }) => {
    const { t } = useTranslation()
    return (
        <Box display='flex' flexDirection='column' gap='16px' height='100%'>
            <Box marginBottom={isEnabled ? '16px' : '0px'}>
                <Box fontWeight={500} fontSize='20px' marginBottom={isEnabled ? '0px' : '8px'}>
                    {t('BRANCH.TAB.SENTTING.ALERT_XRAY_BEFORE_PAYMENT')}
                </Box>
            </Box>
            {isEnabled && (
                <Box display='flex' alignItems={'center'} gap={'16px'} flexDirection={'column'}>
                    <Box textAlign='center' sx={{ img: { width: '80%' } }}>
                        <img src={checkListOperative} alt="" />
                    </Box>
                </Box>
            )}
            <Box>
                <Box fontWeight={500} fontSize='16px' marginBottom='8px'>
                    {isEnabled ? t('BRANCH.TAB.SENTTING.PATTERN_ALERT_XRAY.SHOW') : t('BRANCH.TAB.SENTTING.PATTERN_ALERT_XRAY.NOT_SHOW')}
                </Box>
                <Box fontWeight={400} paddingLeft='16px' color={colors.textLightGray}>
                    {isEnabled ? t('BRANCH.TAB.SENTTING.PATTERN_ALERT_XRAY.SUB_PATTERN') : t('BRANCH.TAB.SENTTING.PATTERN_ALERT_XRAY.NOT_SUB_PATTERN')}
                </Box>
            </Box>
        </Box>
    )
}

// Preview component for Alert Medicine
const AlertMedicinePreview = ({ isEnabled }: { isEnabled: boolean }) => {
    const { t } = useTranslation()
    return (
        <Box display='flex' flexDirection='column' gap='16px' height='100%'>
            <Box marginBottom={isEnabled ? '16px' : '0px'}>
                <Box fontWeight={500} fontSize='20px' marginBottom={isEnabled ? '0px' : '8px'}>
                    {t('BRANCH.TAB.SENTTING.ALERT_MEDICINE_BEFORE_PAYMENT')}
                </Box>
            </Box>
            {isEnabled && (
                <Box display='flex' alignItems={'center'} gap={'16px'} flexDirection={'column'}>
                    <Box textAlign='center' sx={{ img: { width: '80%' } }}>
                        <img src={checkListOperative} alt="" />
                    </Box>
                </Box>
            )}
            <Box>
                <Box fontWeight={500} fontSize='16px' marginBottom='8px'>
                    {isEnabled ? t('BRANCH.TAB.SENTTING.PATTERN_ALERT_MEDICINE.SHOW') : t('BRANCH.TAB.SENTTING.PATTERN_ALERT_MEDICINE.NOT_SHOW')}
                </Box>
                <Box fontWeight={400} paddingLeft='16px' color={colors.textLightGray}>
                    {isEnabled ? t('BRANCH.TAB.SENTTING.PATTERN_ALERT_MEDICINE.SUB_PATTERN') : t('BRANCH.TAB.SENTTING.PATTERN_ALERT_MEDICINE.NOT_SUB_PATTERN')}
                </Box>
            </Box>
        </Box>
    )
}

// Preview component for Alert Teeth
const AlertTeethPreview = ({ isEnabled }: { isEnabled: boolean }) => {
    const { t } = useTranslation()
    return (
        <Box display='flex' flexDirection='column' gap='16px' height='100%'>
            <Box marginBottom={isEnabled ? '16px' : '0px'}>
                <Box fontWeight={500} fontSize='20px' marginBottom={isEnabled ? '0px' : '8px'}>
                    {t('BRANCH.TAB.SENTTING.ALERT_TEETH_BEFORE_PAYMENT')}
                </Box>
            </Box>
            <Box display='flex' alignItems={'center'} gap={'16px'} flexDirection={'column'}>
                <Box textAlign='center' sx={{ img: { width: '80%' } }}>
                    <img src={isEnabled ? checkTeethTrue : checkTeethFalse} alt="" />
                </Box>
            </Box>
            <Box>
                <Box fontWeight={500} fontSize='16px' marginBottom='8px'>
                    {isEnabled ? t('BRANCH.TAB.SENTTING.PATTERN_ALERT_TEETH.SHOW') : t('BRANCH.TAB.SENTTING.PATTERN_ALERT_TEETH.NOT_SHOW')}
                </Box>
                <Box fontWeight={400} paddingLeft='16px' color={colors.textLightGray}>
                    {isEnabled ? t('BRANCH.TAB.SENTTING.PATTERN_ALERT_TEETH.SUB_PATTERN') : t('BRANCH.TAB.SENTTING.PATTERN_ALERT_TEETH.NOT_SUB_PATTERN')}
                </Box>
            </Box>
        </Box>
    )
}

// Preview component for Require Finance Acknowledge
const RequireFinanceAcknowledgePreview = ({ isEnabled }: { isEnabled: boolean }) => {
    return (
        <Box display='flex' flexDirection='column' gap='16px'>
            <Box fontWeight={500} fontSize='20px'>การเงินเซ็นรับทราบก่อนอนุมัติค้างชำระ</Box>
            <Box color={colors.textLightGray}>
                {isEnabled
                    ? 'เมื่อสร้างคำขอค้างชำระ พนักงานการเงินต้องเซ็นรับทราบก่อน จึงจะส่งไปยังผู้อนุมัติ'
                    : 'คำขอค้างชำระจะส่งไปยังผู้อนุมัติโดยตรง ไม่ต้องผ่านการเงินเซ็นรับทราบ'
                }
            </Box>
        </Box>
    )
}

// Preview component for Allow New Patient Registration
const AllowNewPatientRegistrationPreview = ({ isEnabled }: { isEnabled: boolean }) => {
    return (
        <Box display='flex' flexDirection='column' gap='16px' height='100%'>
            <Box marginBottom={isEnabled ? '16px' : '0px'}>
                <Box fontWeight={500} fontSize='20px' marginBottom={isEnabled ? '0px' : '8px'}>
                    การแสดงประเภทผู้ป่วย
                </Box>
            </Box>
            <Box display='flex' alignItems={'center'} gap={'16px'} flexDirection={'column'}>
                <Box textAlign='center' sx={{ img: { width: '80%' } }}>
                    <img src={isEnabled ? registerTrue : registerFalse} alt="" />
                </Box>
            </Box>
            <Box>
                <Box fontWeight={500} fontSize='16px' marginBottom='8px'>
                    {isEnabled ? 'เปิดใช้งาน' : 'ปิดใช้งาน'}
                </Box>
                <Box fontWeight={400} paddingLeft='16px' color={colors.textLightGray}>
                    {isEnabled
                        ? 'ระบบจะแสดงตัวเลือกประเภทผู้ป่วย'
                        : 'ระบบจะไม่แสดงตัวเลือกประเภทผู้ป่วย'
                    }
                </Box>
            </Box>
        </Box>
    )
}